import React from "react";

const Skills = () => (
  <main>
    <div className="home-grid">
      <div className="main-header">
        <h1>My Skills</h1>
      </div>
      <div className="skills-text-container">
        <h3>Frontend and Markup Languages</h3>
        <ul>
          <li>JavaScript</li>
          <li>React</li>
          <li>Pug</li>
          <li>HTML</li>
          <li>CSS</li>
          <li>Sass</li>
          <li>Markdown</li>
        </ul>
        <h3>Backend Languages and Tools</h3>
        <ul>
          <li>NodeJS</li>
          <li>ExpressJS</li>
          <li>SQL</li>
          <li>Wordpress</li>
        </ul>
        <h3>Deployment Platforms</h3>
        <ul>
          <li>Google Cloud Platform</li>
          <li>Wordpress.com</li>
          <li>Netlify</li>
          <li>GitHub Pages</li>
        </ul>
        <h3>Favorite Development Tools</h3>
        <ul>
          <li>Git</li>
          <li>GitHub</li>
          <li>VSCode</li>
          <li>Figma</li>
          <li>Postman</li>
          <li>Typora</li>
          <li>MindManager</li>
        </ul>
      </div>
    </div>
  </main>
);

export default Skills;
